/* CHIEF theme behaviour. Plain JS, no dependencies. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };

  function toast(m) { var t = $('#toast'); if (!t) return; t.textContent = m; t.hidden = false; clearTimeout(t._h); t._h = setTimeout(function () { t.hidden = true; }, 2200); }

  /* drawers */
  function openDrawer(id) { var d = document.getElementById(id); if (!d) return; $('#scrim').hidden = false; d.hidden = false; var c = d.querySelector('[data-close]'); if (c) c.focus(); }
  function closeDrawers() { var s = $('#scrim'); if (s) s.hidden = true; $$('.drawer').forEach(function (d) { d.hidden = true; }); }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-sizeguide]')) { e.preventDefault(); openDrawer('sizeDrawer'); }
    if (e.target.closest('[data-close]') || e.target.id === 'scrim') closeDrawers();
    if (e.target.closest('[data-announce-close]')) { var a = $('#announce'); if (a) a.hidden = true; }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });
  var shipBtn = $('#shipBtn'); if (shipBtn) shipBtn.addEventListener('click', function () { openDrawer('shipDrawer'); });

  /* announcement rotation */
  (function () {
    var el = $('#announceText'); if (!el) return;
    var msgs; try { msgs = JSON.parse(el.getAttribute('data-msgs')).filter(Boolean); } catch (e) { return; }
    if (!msgs || msgs.length < 2) return;
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) { el.textContent = msgs.join(' + '); return; }
    var i = 0;
    setInterval(function () { el.style.opacity = 0; setTimeout(function () { i = (i + 1) % msgs.length; el.textContent = msgs[i]; el.style.opacity = 1; }, 400); }, 4500);
  })();

  /* shop menu */
  (function () {
    var b = $('#shopBtn'), m = $('#shopMenu'); if (!b || !m) return;
    b.addEventListener('click', function (e) { e.stopPropagation(); m.hidden = !m.hidden; b.setAttribute('aria-expanded', String(!m.hidden)); });
    document.addEventListener('click', function (e) { if (!m.contains(e.target)) { m.hidden = true; b.setAttribute('aria-expanded', 'false'); } });
  })();

  /* opening film: load only the version that is visible (landscape desktop, portrait mobile) */
  (function () {
    var f = $('.film'); if (!f) return;
    var mq = matchMedia('(max-width:700px)');
    var v = null;
    function pick() {
      var want = f.querySelector(mq.matches ? '.v-port' : '.v-land') || f.querySelector('video');
      if (!want || want === v) return;
      if (v) v.pause();
      v = want;
      if (!v.getAttribute('src') && v.dataset.src) v.src = v.dataset.src;
      v.muted = true; v.autoplay = true;
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    }
    pick();
    if (mq.addEventListener) mq.addEventListener('change', pick); else if (mq.addListener) mq.addListener(pick);
    var b = $('#filmPause');
    if (b) b.addEventListener('click', function () { if (!v) return; if (v.paused) { v.play(); b.textContent = 'Pause'; b.setAttribute('aria-pressed', 'false'); } else { v.pause(); b.textContent = 'Play'; b.setAttribute('aria-pressed', 'true'); } });
    var L = $('#filmListen'), P = $('#listenPanel'), X = $('#listenClose');
    if (L && P) {
      var tog = function (o) { P.hidden = !o; L.setAttribute('aria-expanded', String(o)); };
      L.addEventListener('click', function () { tog(P.hidden); });
      if (X) X.addEventListener('click', function () { tog(false); });
    }
  })();

  /* other looping videos: make sure they play when on screen */
  (function () {
    var vids = $$('main video[autoplay]').filter(function (x) { return !x.closest('.film'); });
    vids.forEach(function (x) { x.muted = true; });
    if (!('IntersectionObserver' in window)) { vids.forEach(function (x) { var p = x.play(); if (p && p.catch) p.catch(function () {}); }); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { var p = e.target.play(); if (p && p.catch) p.catch(function () {}); } else { e.target.pause(); } }); }, { threshold: 0.2 });
    vids.forEach(function (x) { io.observe(x); });
  })();

  /* rail tabs */
  $$('[data-rail-tab]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var tabs = btn.parentNode.querySelectorAll('[data-rail-tab]');
      Array.prototype.forEach.call(tabs, function (t) {
        var on = t === btn; t.setAttribute('aria-selected', String(on));
        var r = document.getElementById(t.getAttribute('data-rail-tab')); if (r) { r.hidden = !on; if (on) r.scrollLeft = 0; }
      });
    });
  });

  /* saved (this browser only) */
  var SAVED = (function () { try { return JSON.parse(localStorage.getItem('chiefSaved') || '[]'); } catch (e) { return []; } })();
  function persistSaved() { try { localStorage.setItem('chiefSaved', JSON.stringify(SAVED)); } catch (e) {} var c = $('#savedCount'); if (c) c.textContent = SAVED.length; }
  persistSaved();
  function toggleSave(h) { var i = SAVED.indexOf(h); if (i > -1) SAVED.splice(i, 1); else SAVED.push(h); persistSaved(); toast(SAVED.indexOf(h) > -1 ? 'Saved' : 'Removed from saved'); }
  (function () {
    var grid = $('#savedGrid'); if (!grid) return;
    var n = 0;
    $$('[data-saved-item]', grid).forEach(function (el) { var on = SAVED.indexOf(el.getAttribute('data-saved-item')) > -1; el.hidden = !on; if (on) n++; });
    var intro = $('#savedIntro'); if (intro) intro.textContent = n ? intro.getAttribute('data-some') : intro.getAttribute('data-empty');
  })();

  /* collection filters */
  (function () {
    var grid = $('#grid'); if (!grid || !$('#filters')) return;
    var q = new URLSearchParams(location.search);
    var F = { cat: q.get('cat') || 'all', metal: q.get('metal') || 'all', fam: q.get('fam') || null, look: q.get('look') || null };
    var fams = {};
    (grid.getAttribute('data-families') || '').split('\n').forEach(function (l) { var p = l.split('|'); if (p.length >= 2) fams[p[0].trim()] = { t: p[1].trim(), i: (p[2] || '').trim() }; });
    var title = $('#shopTitle'), eyebrow = $('#shopEyebrow'), intro = $('#shopIntro');
    if (F.fam && fams[F.fam]) { title.textContent = fams[F.fam].t; eyebrow.textContent = 'Family'; intro.textContent = fams[F.fam].i; intro.hidden = !fams[F.fam].i; document.title = fams[F.fam].t + ' | CHIEF'; }
    else if (F.look) { var nm = F.look.replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); }); title.textContent = nm; eyebrow.textContent = 'The look'; intro.hidden = true; }
    else if (F.cat !== 'all') { title.textContent = F.cat; eyebrow.textContent = 'Category'; if (F.cat === 'Rings') { intro.textContent = 'See the ring size guide before you order.'; intro.hidden = false; } else { intro.hidden = true; } document.title = F.cat + ' | CHIEF'; }
    var tiles = $$('.tile', grid), plate = $('[data-plate]', grid), empty = $('#emptyState');
    tiles.forEach(function (t, i) { t.dataset.order = i; });
    function render() {
      var shown = 0;
      tiles.forEach(function (t) {
        var ok = (F.cat === 'all' || t.dataset.cat === F.cat) && (F.metal === 'all' || t.dataset.metal === F.metal) && (!F.fam || t.dataset.fam === F.fam) && (!F.look || (' ' + t.dataset.looks + ' ').indexOf(' ' + F.look + ' ') > -1);
        t.hidden = !ok; if (ok) shown++;
      });
      var s = $('#sort').value;
      var sorted = tiles.slice().sort(function (a, b) { return s === 'asc' ? a.dataset.price - b.dataset.price : s === 'desc' ? b.dataset.price - a.dataset.price : a.dataset.order - b.dataset.order; });
      sorted.forEach(function (t) { grid.insertBefore(t, empty); });
      if (plate) { var vis = sorted.filter(function (t) { return !t.hidden; }); if (vis.length > 6 && !F.fam && !F.look) { grid.insertBefore(plate, vis[4]); plate.hidden = false; } else { plate.hidden = true; } }
      $('#count').textContent = shown + (shown === 1 ? ' piece' : ' pieces');
      if (empty) empty.hidden = shown > 0;
      $$('.fgroup[data-key]').forEach(function (g) { $$('button', g).forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.v === F[g.dataset.key])); }); });
    }
    $$('.fgroup[data-key] button').forEach(function (b) { b.addEventListener('click', function () { F[b.closest('.fgroup').dataset.key] = b.dataset.v; render(); }); });
    $('#sort').addEventListener('change', render);
    var clr = $('#clearF'); if (clr) clr.addEventListener('click', function () { F.cat = 'all'; F.metal = 'all'; F.fam = null; F.look = null; render(); });
    render();
  })();

  /* cart */
  function setCount(n) { var c = $('#bagCount'); if (c) c.textContent = n; }
  function loadBag() {
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + '?sections=bag-drawer', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var b = $('#bagBody'); if (!b) return;
        b.innerHTML = j['bag-drawer'] || '';
        var wrap = b.querySelector('[data-count]'); if (wrap) setCount(wrap.getAttribute('data-count'));
        $$('[data-q]', b).forEach(function (btn) {
          btn.addEventListener('click', function () {
            btn.disabled = true;
            fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: btn.dataset.q, quantity: +btn.dataset.v }) })
              .then(function () { return loadBag(); });
          });
        });
      });
  }
  var bagBtn = $('#bagBtn');
  if (bagBtn) bagBtn.addEventListener('click', function (e) { e.preventDefault(); loadBag().then(function () { openDrawer('bagDrawer'); }); });

  /* product page */
  (function () {
    var pdp = $('.pdp'); if (!pdp) return;
    var handle = pdp.getAttribute('data-product');
    var save = $('#saveBtn');
    if (save) {
      var sync = function () { var on = SAVED.indexOf(handle) > -1; save.setAttribute('aria-pressed', String(on)); save.textContent = on ? 'Saved' : 'Save'; };
      sync(); save.addEventListener('click', function () { toggleSave(handle); sync(); });
    }
    var form = $('#productForm'), vid = $('#variantId'), add = $('#addBtn'), note = $('#sizeNote'), nb = $('#notifyBox'), nl = $('#notifyLabel'), piece = $('#notifyPiece');
    var sizeBtns = $$('.sizes .row button');
    var chosen = sizeBtns.length ? null : (vid && vid.value);
    var mode = 'std';
    sizeBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        sizeBtns.forEach(function (o) { o.setAttribute('aria-pressed', String(o === b)); });
        if (mode === 'gold') return;
        if (b.dataset.a === '0') {
          chosen = null; if (nb) { nb.hidden = false; nl.textContent = 'Size ' + b.dataset.s + ' is gone. Leave your email and you’ll hear first.'; if (piece) piece.value = piece.value.split(' / Size')[0] + ' / Size ' + b.dataset.s; }
          if (note) note.textContent = ''; return;
        }
        chosen = b.dataset.variant; vid.value = chosen; if (nb && add) nb.hidden = true; if (note) { note.textContent = 'Size ' + b.dataset.s + ' selected.'; note.style.color = ''; }
      });
    });
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (sizeBtns.length && !chosen) { if (note) { note.textContent = 'Choose a size first.'; note.style.color = 'var(--ink)'; } return; }
      add.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +vid.value, quantity: 1 }] }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { return loadBag(); })
        .then(function () { openDrawer('bagDrawer'); })
        .catch(function (err) { toast((err && err.description) || 'Could not add to bag'); })
        .then(function () { add.disabled = false; });
    });
    $$('.metalpick button').forEach(function (b) {
      b.addEventListener('click', function () {
        mode = b.dataset.m; $$('.metalpick button').forEach(function (o) { o.setAttribute('aria-pressed', String(o === b)); });
        var gold = mode === 'gold';
        var price = $('#priceTxt'), mat = $('#matTxt'), gb = $('#goldBox'), dl = $('#deliveryLine'), specs = $('#specList');
        if (price) price.textContent = gold ? 'Price on application' : price.getAttribute('data-std');
        if (mat) mat.textContent = gold ? '14k solid gold, made to order' : mat.getAttribute('data-std');
        if (gb) gb.hidden = !gold;
        if (form) form.hidden = gold && !sizeBtns.length;
        if (add) add.hidden = gold;
        if (note) note.hidden = gold;
        if (nb) nb.hidden = gold || !!add;
        if (dl) dl.hidden = gold;
        if (specs) { if (!specs._std) specs._std = specs.innerHTML; specs.innerHTML = gold ? specs.getAttribute('data-gold').split('|').map(function (t) { return '<li>' + esc(t) + '</li>'; }).join('') : specs._std; }
        sizeBtns.forEach(function (o) { o.classList.toggle('out', !gold && o.dataset.a === '0'); });
      });
    });
  })();

  /* concierge */
  (function () {
    var c = $('#copyAddr');
    if (c) c.addEventListener('click', function () {
      var a = $('#concAddr').textContent.trim();
      if (navigator.clipboard) navigator.clipboard.writeText(a).then(function () { c.textContent = 'Copied'; }, function () { c.textContent = 'Select and copy'; });
    });
    var q = new URLSearchParams(location.search), r = $('#bkReason'), n = $('#bkNote');
    if (r && q.get('about') === 'hanneysee') r.value = 'HANNEYSEE commission';
    if (n && q.get('piece') && !n.value) n.value = 'Solid gold enquiry: ' + q.get('piece');
  })();
})();
